export const DEFAULT_LOCALE = 'lt';
export const DEFAULT_ADMIN_LOCALE = 'lt';
export const NO_INFO = '-';

export const DASHBOARD_OVERVIEW_CARD_MAX_AMOUNT_NUMBER = 999999;
export const DEFAULT_CERTIFICATE_SIGN_PRICE = 69;

export const PDF_X = 595.283;
export const PDF_Y = 841.883;
